import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";
import Navbarnft_global from "./Navbars/Navbarnft_global";
import Footer from "./Footer";
import placeholderImage from "../Images/placeholder.svg";
import gold from "../Images/tick_gold.png";
import blue from "../Images/tick_blue.png";
import { useApiList, collectionLink } from "./exploreData";
import "./ExplorePages.css";

const tabs = ["NFTs", "Collections"];
const sortLabels = { new: "Recently listed", name: "Name (A–Z)", rank: "Top ranked" };

const Tick = ({ tick }) =>
  tick === "gold" ? <img src={gold} alt="Sharia compliant" /> : tick === "blue" ? <img src={blue} alt="Verified" /> : null;

function Explore({ UserWallet, signMessage, logout }) {
  const [tab, setTab] = useState(0);
  const [query, setQuery] = useState("");
  const [sort, setSort] = useState("new");
  const nfts = useApiList("/allnewnfts");
  const collections = useApiList("/rank");

  const collectionById = useMemo(() => {
    const map = {};
    (collections || []).forEach((c) => {
      map[c.Collection_id] = c;
      map[c._id] = c;
    });
    return map;
  }, [collections]);

  const items = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (tab === 0) {
      let list = (nfts || []).filter((n) => {
        const c = collectionById[n.collectionID];
        return !q || `${c ? c.name : ""} ${n.tokenID}`.toLowerCase().includes(q);
      });
      if (sort === "new") list = [...list].sort((a, b) => (b.CreatedAt || 0) - (a.CreatedAt || 0));
      return list;
    }
    let list = (collections || []).filter((c) => !q || String(c.name).toLowerCase().includes(q));
    if (sort === "name") list = [...list].sort((a, b) => String(a.name).localeCompare(String(b.name)));
    if (sort === "rank") list = [...list].sort((a, b) => Number(a.rank) - Number(b.rank));
    return list;
  }, [tab, query, sort, nfts, collections, collectionById]);

  const loading = (tab === 0 ? nfts : collections) === null;

  return (
    <>
      <Navbarnft_global UserWallet={UserWallet} signMessage={signMessage} logout={logout} URL={window.apiURL} />
      <div className="w3-container">
        <section className="ex-hero">
          <div className="w3-eyebrow">Marketplace</div>
          <h1>Explore <span className="w3-gradient-text">PanSea</span></h1>
          <p>Browse the latest NFTs and top collections across every category.</p>
          <div className="ex-tabs w3-glass" role="tablist">
            {tabs.map((t, i) => (
              <button key={t} role="tab" aria-selected={tab === i} className={`ex-tab ${tab === i ? "is-active" : ""}`} onClick={() => setTab(i)}>
                {t}
              </button>
            ))}
          </div>
          <div className="ex-toolbar">
            <label className="ex-search w3-glass">
              <AiOutlineSearch />
              <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder={tab === 0 ? "Search NFTs or collections" : "Search collections"} />
            </label>
            <select className="ex-select" value={sort} onChange={(e) => setSort(e.target.value)}>
              {(tab === 0 ? ["new"] : ["rank", "name"]).map((k) => (
                <option key={k} value={k}>{sortLabels[k]}</option>
              ))}
            </select>
            <span className="ex-count">{loading ? "Loading…" : `${items.length} result${items.length === 1 ? "" : "s"}`}</span>
          </div>

          {!loading && items.length === 0 ? (
            <div className="ex-empty">Nothing found. Try a different search.</div>
          ) : (
            <div className="ex-grid">
              {tab === 0
                ? items.map((n) => {
                    const c = collectionById[n.collectionID];
                    return (
                      <Link key={n._id} to={`/assets/${n._id}`} className="ex-card w3-glass">
                        <div className="ex-card-img">
                          <img src={n.imageURL || placeholderImage} alt="" />
                          <span className="ex-badge">#{n.tokenID}</span>
                        </div>
                        <div className="ex-card-body">
                          <div className="ex-card-title">{c ? c.name : "Unnamed collection"}<Tick tick={c && c.tick} /></div>
                          <div className="ex-card-sub">Token #{n.tokenID} · ERC-{n.nftType}</div>
                          <div className="ex-stats">
                            <div><small>Price</small><b>{n.last_sold_price ? `${n.last_sold_price} MAAL` : "Not listed"}</b></div>
                            <div><small>Supply</small><b>{n.supply || 1}</b></div>
                          </div>
                        </div>
                      </Link>
                    );
                  })
                : items.map((c) => (
                    <Link key={c._id} to={collectionLink(c)} className="ex-card w3-glass">
                      <div className="ex-card-img">
                        <img src={c.featureImage || c.logoImage || placeholderImage} alt="" />
                        {c.catogry && <span className="ex-badge">{c.catogry}</span>}
                      </div>
                      <div className="ex-card-body">
                        <div className="ex-card-title">{c.name}<Tick tick={c.tick} /></div>
                        <div className="ex-card-sub">{c.rank ? `Rank #${c.rank}` : "Collection"}</div>
                      </div>
                    </Link>
                  ))}
            </div>
          )}
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Explore;
